// extracted by mini-css-extract-plugin
export default {"card":"AboutCommit_card__Bi31A","image":"AboutCommit_image__+zgU9"};